import(/* webpackMode: "eager", webpackExports: ["AuthGuardProvider"] */ "/opt/atlassian/pipelines/agent/build/app/components/auth/auth-guard-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthGuard"] */ "/opt/atlassian/pipelines/agent/build/app/components/auth/auth-guard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toast"] */ "/opt/atlassian/pipelines/agent/build/app/components/toast/toast.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/app/StoreProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/styles/gradient.css");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/styles/new-ui-styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Figtree\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-figtree\"}],\"variableName\":\"figtree\"}");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
